import gbTinymce from "./src/gb-tinymce.vue";
const gbTinymceCompenet = function(Vue) {
  Vue.component(gbTinymce.name, gbTinymce);
};
export default gbTinymceCompenet;
